import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "backgroundColor compareProductWrap" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("col", { style: {"width":"180px"} }, null, -1)
const _hoisted_3 = { class: "compareProductDescript" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "compareProductDescript" }
const _hoisted_6 = {
  class: "compareProductDescript",
  style: {"vertical-align":"top"}
}
const _hoisted_7 = { class: "image-slot" }
const _hoisted_8 = { class: "compareProductDescript" }
const _hoisted_9 = { style: {"border":"0px","border-collapse":"collapse","width":"100%","padding-right":"3px"} }
const _hoisted_10 = { style: {"width":"100%","border":"none","padding-top":"5px"} }
const _hoisted_11 = { style: {"width":"100%","border":"none","padding-top":"5px"} }
const _hoisted_12 = { style: {"border":"0px","border-collapse":"collapse"} }
const _hoisted_13 = ["title", "innerHTML"]
const _hoisted_14 = {
  class: "compareProductDescript",
  style: {"vertical-align":"top"}
}
const _hoisted_15 = { style: {"border":"0px","border-collapse":"collapse","width":"100%"} }
const _hoisted_16 = ["title", "innerHTML"]
const _hoisted_17 = ["title", "innerHTML"]
const _hoisted_18 = ["title", "innerHTML"]
const _hoisted_19 = ["title", "innerHTML"]
const _hoisted_20 = ["title", "innerHTML"]
const _hoisted_21 = ["title", "innerHTML"]
const _hoisted_22 = { class: "compareProductDescript" }
const _hoisted_23 = { style: {"border":"0px","border-collapse":"collapse","width":"100%","padding-right":"3px"} }
const _hoisted_24 = { style: {"width":"100%","border":"none"} }
const _hoisted_25 = {
  class: "commonTdStyle",
  style: {"width":"100%","text-align":"right","border":"none"}
}
const _hoisted_26 = { style: {"border":"0px","border-collapse":"collapse","width":"250px","overflow-x":"scroll"} }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { style: {"width":"50px","border":"none"} }, " ")
], -1)
const _hoisted_28 = ["title", "innerHTML"]

import { onMounted,reactive } from 'vue'
import $http from '../http/index'
import $helper from '../helper/helper'

// 产品属性信息
interface PD_ItemParameterEntity{
    ID:string,
    ItemModelID:string,
    FieldCode:string,
    FieldName:string,
    FieldValuesString:string,
    FieldValuesStrings:string[],
    GloryModel:string,
}

interface Relevance{
    // 型号关系
    Similar:string,
    // 对应型号
    PartNo:string,
    // 区别说明
    Difference:string
}

interface OtherFeature{
    // 产品分类
    ProductClassify:string,
    // 包装数量
    PackageCount:string,
    // ECER90
    ECER90:string
}

interface BrandProduct{
    Brands:string,
    BrandsModel:string,
    U9Code:string,
    Status:string,
    Series:string,
    Code69Info:string,
    ProductNote:string,
    PriceGuidance:string,
    PriceMedia:string,
    GloryModel:string,
    [key: string]: any;
}

interface BrandProductField{
    id:string
    filedCode:string,
    filedName:string,
    filedValues:Array<string>,
}

// 车型匹配
interface CarModelsInfoMatch{
    // 车型详细信息
    carInfo:string,
    // 品牌 
    Brands:string,
    // 车型 
    CarModel:string,
    // 排量 
    OutputVolume:string,
    // 车辆类别 
    VehicleType:string,
    // 驱动方式
    DrivingModel:string,
    // 上市时间
    SaleTime:string,
    // 上市年份
    SaleYear:string,
    // 上市月份
    SaleMonth:string,
    // 停产时间
    StopTime:string,
    // 停产年份
    StopYear:string,
    // 停产月份
    StopMonth:string,
    // 前刹车 
    BrakeFront:string,
    // 后刹车 
    BrakeAfter:string,
    // 手刹片 
    HandBrake:string,
    // 前刹车盘 
    BrakeDiscFront:string,
    // 后刹车盘 
    BrakeDiscAfter:string,
    // 前报警线
    AlarmLineFront:string,
    // 后报警线
    AlarmLineAfter:string,
    // 车型匹配编号区别 
    Note:string,
    // 保有量 
    Retention:string,
    // 市场来源
    MarketSource:string,
}

// 品牌编码
interface BrandCode{
    MCType:string,
    BrandsOther:string,
    OtherCode:string,
    Remark:string
}

// 产品图片
interface PictureFile{
    ID:string,
    PictureFileURL:string
}

interface MoreProductInfoDTO{
    GloryModel:string,
    ProductSize:PD_ItemParameterEntity[],
    Relevances:Relevance[],
    OtherFeatures:OtherFeature[],
    BrandProducts:BrandProduct[],
    CarModelsInfoMatchs:CarModelsInfoMatch[],
    BrandCodes:BrandCode[],
    PictureFiles:PictureFile[]
}

interface CodeSearchDTO{
    TypeCode:string,
    TypeCodeClassfy:string,
    GloryModel: string,
    GloryModelGuid: string,//唯一
    ShowName:  string,
    ShowName2:  string,
    Position:string, // 安装位置
    ReplaceRemark: string,
    ProductSizes: string[],
    MapCode: string,
    PictureFileID:string,
    PictureFileURL:string,
    ShowMoreProductInfo:boolean,
    ShowDetailProductInfo:boolean,
    Note:string,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CompareProduct',
  setup(__props) {

class InitData{
    compareProducts:Array<CodeSearchDTO>=[]
    moreProductInfoDTOes:Array<MoreProductInfoDTO>=[]
    contentColWidth=250  //内容列  
    productImageStyle={
        "width": "250px", 
        "height": "250px"
    }
    productSizesShow:Array<PD_ItemParameterEntity>=[]
    productSizesFields:Array<string> = []
    productSizesFieldName:Array<string> = []
    brandProductFields:Array<BrandProductField>=[
        {filedCode:"Brands",filedName:"品牌",filedValues:[],id:$helper.createID()},
        {filedCode:"BrandsModel",filedName:"品牌型号",filedValues:[],id:$helper.createID()},
        {filedCode:"U9Code",filedName:"U9编码",filedValues:[],id:$helper.createID()},
        {filedCode:"Status",filedName:"产品状态",filedValues:[],id:$helper.createID()},
        {filedCode:"Series",filedName:"产品系列",filedValues:[],id:$helper.createID()},
        {filedCode:"Code69Info",filedName:"69码信息",filedValues:[],id:$helper.createID()},
        {filedCode:"ProductNote",filedName:"产品备注",filedValues:[],id:$helper.createID()},
        {filedCode:"PriceGuidance",filedName:"指导价",filedValues:[],id:$helper.createID()},
        {filedCode:"PriceMedia",filedName:"媒体价",filedValues:[],id:$helper.createID()}
    ]
    scaleValue=1 //放大
}

const data = reactive(new InitData());

/**
 * 一个产品的尺寸
 * @param gloryModel 
 */
const calOneProductSize=(gloryModel:string):Array<PD_ItemParameterEntity>=>{
    let oneproductSizesShow:Array<PD_ItemParameterEntity>=[]
    for(let i=0;i<data.productSizesFields.length;i++){
        let temp = data.productSizesShow.filter(c=>c.GloryModel == gloryModel && c.FieldCode ==data.productSizesFields[i]);
        if(temp && temp.length>0){
            oneproductSizesShow.push(temp[0])
        }else{
            let productSize:PD_ItemParameterEntity={
                ID:`productSizeShowID${i}`,
                ItemModelID:'',
                FieldCode:'',
                FieldName:'',
                FieldValuesString:'',
                FieldValuesStrings:['&nbsp;'],
                GloryModel:''
            };
            oneproductSizesShow.push(productSize)
        }
    }
    return oneproductSizesShow;
}

/**
 * 一个产品的尺寸数量
 * @param gloryModel 
 */
const calOneProductSizeCount=(gloryModel:string):Array<string>=>{
    let count = 0;
    let oneProductSize = calOneProductSize(gloryModel);
    for(let i=0;i<oneProductSize.length;i++){
        if(oneProductSize&& oneProductSize[i].FieldValuesStrings.length>count){
            count=oneProductSize[i].FieldValuesStrings.length;
        }
    }
    let sizeTest:Array<string> = [] 
    for(let i=1;i<count+1;i++){
        let text = $helper.lan('尺寸');
        if(count>1){
            text = text + i;
        }
        sizeTest.push(text);
    }
    return sizeTest;
}

/**
 * 一个产品的关联特征
 * @param gloryModel 
 */
const getRelevances=(gloryModel:string):Array<Relevance>=>{
    let dto = data.moreProductInfoDTOes.filter(c=>c.GloryModel==gloryModel);
    if(dto.length>0){
        return dto[0].Relevances;
    }
    return [];
}

/**
 * 处理尺寸数据
 */ 
const productSizeDataHandle = (dto:MoreProductInfoDTO)=>{
    if(!dto.ProductSize || dto.ProductSize.length<0){
        return;
    }
    let productSizes = dto.ProductSize;
    let itemModelIDs:string[] = []
    let fieldCodes:string[] = []
    let fieldNames:string[] = []
    for(let i=0;i<productSizes.length;i++){
        if(itemModelIDs.indexOf(productSizes[i].ItemModelID)<0){
            itemModelIDs.push(productSizes[i].ItemModelID);
        }
        if(fieldCodes.indexOf(productSizes[i].FieldCode)<0){
            fieldCodes.push(productSizes[i].FieldCode);
            fieldNames.push(productSizes[i].FieldName);
        }
        if(data.productSizesFields.indexOf(productSizes[i].FieldCode)<0){
            data.productSizesFields.push(productSizes[i].FieldCode)
            data.productSizesFieldName.push(productSizes[i].FieldName)
        }
    }
    for(let i=0;i<fieldCodes.length;i++){
        let fieldCode = fieldCodes[i];
        let fieldName = fieldNames[i];
        let productSize:PD_ItemParameterEntity={
            ID:`productSizeShowID${i}`,
            ItemModelID:'',
            FieldCode:fieldCode,
            FieldName:fieldName,
            FieldValuesString:'',
            FieldValuesStrings:[],
            GloryModel:dto.GloryModel
        };
        for(let j=0;j<itemModelIDs.length;j++){
            let itemModelID = itemModelIDs[j]
            let currentSize = productSizes.filter(c=>c.FieldCode==fieldCode&&c.ItemModelID==itemModelID);
            if(currentSize.length>0){
                productSize.FieldValuesStrings.push(currentSize[0].FieldValuesString);
            }else{
                productSize.FieldValuesStrings.push('');
            }
        }
        data.productSizesShow.push(productSize);
    }
}

/**
 * 一个产品的品牌
 * @param gloryModel 
 */
const calBrandProducts=(gloryModel:string):Array<BrandProductField>=>{
    let dto = data.moreProductInfoDTOes.filter(c=>c.GloryModel==gloryModel);
    if(dto.length<=0){
        return [];
    }
    let result:Array<BrandProductField> = []
    for(let i=0;dto[0].BrandProducts && i<dto[0].BrandProducts.length && i<3;i++){
        let brandProduct =dto[0].BrandProducts[i];
        for(let j=0;j<data.brandProductFields.length;j++){
            let filedCode = data.brandProductFields[j].filedCode;   
            let filedValue = brandProduct[filedCode]
            let index = result.findIndex(c=>c.filedCode==filedCode);
            if(index<0){
                let addBrandProductField = JSON.parse(JSON.stringify(data.brandProductFields[j])) as BrandProductField;
                result.push(addBrandProductField)
                index = result.length-1;
            }
            if(!filedValue){
                filedValue = "&nbsp;"
            }
            result[index].filedValues.push(filedValue)
        }
    }
    return result;
}

const calBrandProductsShowField=()=>{
    let allBrandProduct:Array<BrandProduct> = [];
    for(let i=0;data.moreProductInfoDTOes && i<data.moreProductInfoDTOes.length;i++){
        if(!data.moreProductInfoDTOes[i].BrandProducts){
            continue;
        }
        // 产品取消对比，相关的品牌不再参加运行
        if(data.compareProducts.findIndex(c=>c.GloryModel ==data.moreProductInfoDTOes[i].GloryModel)<0){
            continue;
        }
        let addBrandProducts = data.moreProductInfoDTOes[i].BrandProducts.length<3?
            data.moreProductInfoDTOes[i].BrandProducts:
            data.moreProductInfoDTOes[i].BrandProducts.slice(0,3);//一个产品默认最多展示3个品牌信息
        allBrandProduct = allBrandProduct.concat(addBrandProducts)
    }
    let codes:Array<string> = [];
    for(let i=0;i<allBrandProduct.length;i++){
        let brandProduct = allBrandProduct[i];
        for(let j = 0;j<data.brandProductFields.length;j++){
            let filedCode = data.brandProductFields[j].filedCode;   
            let filedValue = brandProduct[filedCode];
            if(filedValue){
                codes.push(filedCode);
            }
        }
    }
    data.brandProductFields = data.brandProductFields.filter(c=>codes.indexOf(c.filedCode)>-1);
}

/**
 * 关联特征样式
 * @param widthPercent 
 */
const sizeTdStyle=(widthPercent:number):any=>{
    let width = widthPercent * data.contentColWidth / 100 - 3;
    return {
        'border': 'none',
        'width':`${width}px`
    }
}

/**
 * 关联特征样式
 * @param widthPercent 
 */
const relevanceTdStyle=(widthPercent:number):any=>{
    let width = widthPercent * data.contentColWidth / 100 - 3;
    return {
        'border': 'none',
        'width':`${width}px`
    }
}

/**
 * 品牌特征样式
 * @param widthPercent 
 */
const brandProductTdStyle=(widthPercent:number):any=>{
    let width = widthPercent * data.contentColWidth / 100 - 3;
    return {
        'border': 'none',
        'width':`${width}px`
    }
}

/**
 * 移除对比产品
 * @param gloryModel 
 */
const removeCompareProduct=(gloryModel:string)=>{
    let index = data.compareProducts.findIndex(c=>c.GloryModel ==gloryModel);
    if(index<0) {
        return;
    }
    data.compareProducts.splice(index,1);
    window.localStorage.setItem("addOrRemoveCompareProduct",JSON.stringify(data.compareProducts));
    calBrandProductsShowField();
}

/**
 * 放大
 */
const enlarge =()=>{
    if(data.scaleValue>5)return;
    data.scaleValue=data.scaleValue+0.1;
    window.localStorage.setItem("scaleValue",`${data.scaleValue}`);
}

/**
 * 缩小
 */
const reduce =()=>{
    if(data.scaleValue<0.5)return;
    data.scaleValue=data.scaleValue-0.1;
    window.localStorage.setItem("scaleValue",`${data.scaleValue}`);
}

/**
 * 重置
 */
const resetSize=()=>{
    data.scaleValue=1;
    window.localStorage.setItem("scaleValue",`${data.scaleValue}`);
}


onMounted(()=>{
    init();
    let cacheValue = window.localStorage.getItem("scaleValue");
    if(cacheValue){
        data.scaleValue = Number.parseFloat(cacheValue);
    }
})

const init = ()=>{
    let compareProducts = window.localStorage.getItem("addOrRemoveCompareProduct");
        if( !compareProducts || compareProducts.length < 1){
        data.compareProducts = [];
    }else{
        data.compareProducts = JSON.parse(compareProducts);
    }
    data.productImageStyle.width=`${data.contentColWidth+5}px`;
    data.productImageStyle.height=`${data.contentColWidth+5}px`;

    let typeCode = '';
    let gloryModels:Array<string> = [];
    for(let i=0;i<data.compareProducts.length;i++){
        if(i==0){
            typeCode=data.compareProducts[i].TypeCode;
        }
        gloryModels.push(data.compareProducts[i].GloryModel)
    }    

    $http({
        url: `/API/Product/GetCompareProducts`,
        method: "POST",
        data: {
            gloryModels:JSON.stringify(gloryModels),
            typeCode:typeCode
        }
    }).then(res => {
        data.moreProductInfoDTOes = res.data;
         // 处理尺寸显示
        for(let i=0;data.moreProductInfoDTOes && i<data.moreProductInfoDTOes.length;i++){
            productSizeDataHandle(data.moreProductInfoDTOes[i]);
        }
        calBrandProductsShowField();
    })
}

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_icon_picture = _resolveComponent("icon-picture")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", null, "暂时数据", 512), [
      [_vShow, data.compareProducts.length<1]
    ]),
    _withDirectives(_createElementVNode("table", {
      class: "wrapTable",
      style: _normalizeStyle({ transform: `scale(${data.scaleValue})`,transformOrigin:'top left' })
    }, [
      _createElementVNode("colgroup", null, [
        _hoisted_2,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.compareProducts, (item) => {
          return (_openBlock(), _createElementBlock("col", {
            style: {"width":"250px"},
            key: item.GloryModel
          }))
        }), 128))
      ]),
      _createElementVNode("tr", null, [
        _createElementVNode("td", _hoisted_3, [
          _createElementVNode("strong", null, _toDisplayString(_unref($helper).lan('产品编码')) + " ", 1)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.compareProducts, (item) => {
          return (_openBlock(), _createElementBlock("td", {
            key: item.GloryModel
          }, [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 18 }, {
                  default: _withCtx(() => [
                    _createTextVNode("  " + _toDisplayString(item.GloryModel), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_el_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      style: {"cursor":"pointer"},
                      onClick: ($event: any) => (removeCompareProduct(item.GloryModel))
                    }, _toDisplayString(_unref($helper).lan('取消')) + " X ", 9, _hoisted_4)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ]))
        }), 128))
      ]),
      _createElementVNode("tr", null, [
        _createElementVNode("td", _hoisted_5, [
          _createElementVNode("strong", null, _toDisplayString(_unref($helper).lan('安装位置')) + "  ", 1)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.compareProducts, (item) => {
          return (_openBlock(), _createElementBlock("td", {
            key: item.GloryModel
          }, "  " + _toDisplayString(_unref($helper).lan(item.Position)), 1))
        }), 128))
      ]),
      _createElementVNode("tr", null, [
        _createElementVNode("td", _hoisted_6, [
          _createElementVNode("strong", null, _toDisplayString(_unref($helper).lan('图片信息')) + " ", 1)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.compareProducts, (item) => {
          return (_openBlock(), _createElementBlock("td", {
            key: item.GloryModel
          }, [
            _createVNode(_component_el_image, {
              style: {"width":"250px","height":"250px"},
              src: item.PictureFileURL,
              fit: "contain"
            }, {
              error: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_icon_picture)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 2
            }, 1032, ["src"])
          ]))
        }), 128))
      ]),
      _createElementVNode("tr", null, [
        _createElementVNode("td", _hoisted_8, [
          _createElementVNode("table", _hoisted_9, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_10, [
                _createElementVNode("strong", null, _toDisplayString(_unref($helper).lan('产品尺寸特征')) + " ", 1)
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.productSizesFieldName, (fieldName) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: fieldName,
                style: {"width":"100%"}
              }, [
                _createElementVNode("td", _hoisted_11, [
                  _createElementVNode("strong", null, _toDisplayString(fieldName) + " ", 1)
                ])
              ]))
            }), 128))
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.compareProducts, (item) => {
          return (_openBlock(), _createElementBlock("td", {
            key: item.GloryModel
          }, [
            _createElementVNode("table", _hoisted_12, [
              _createElementVNode("tr", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(calOneProductSizeCount(item.GloryModel), (i) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: i,
                    style: {"text-align":"left","border":"none","padding-left":"3px","padding-top":"5px"}
                  }, [
                    _createElementVNode("strong", null, _toDisplayString(i), 1)
                  ]))
                }), 128))
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(calOneProductSize(item.GloryModel), (size) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: size.ID
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(size.FieldValuesStrings, (s) => {
                    return (_openBlock(), _createElementBlock("td", {
                      key: s+_unref($helper).createID(),
                      style: {"width":"60px","border":"none","text-align":"left","padding-left":"3px","padding-top":"5px"}
                    }, [
                      _createElementVNode("div", {
                        class: "oneRowText",
                        style: _normalizeStyle(sizeTdStyle(38)),
                        title: s,
                        innerHTML: s
                      }, null, 12, _hoisted_13)
                    ]))
                  }), 128))
                ]))
              }), 128))
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("tr", null, [
        _createElementVNode("td", _hoisted_14, [
          _createElementVNode("strong", null, _toDisplayString(_unref($helper).lan('关联特征')) + " ", 1)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.compareProducts, (item) => {
          return (_openBlock(), _createElementBlock("td", {
            key: item.GloryModel,
            style: {"vertical-align":"top"}
          }, [
            _createElementVNode("table", _hoisted_15, [
              _withDirectives(_createElementVNode("tr", null, [
                _createElementVNode("td", {
                  class: "commonTdStyle",
                  style: _normalizeStyle(relevanceTdStyle(30))
                }, [
                  _createElementVNode("div", {
                    class: "oneRowText",
                    style: _normalizeStyle(relevanceTdStyle(30)),
                    title: _unref($helper).lan('型号关系'),
                    innerHTML: '<strong>'+_unref($helper).lan('型号关系')+'</strong>'
                  }, null, 12, _hoisted_16)
                ], 4),
                _createElementVNode("td", {
                  class: "commonTdStyle",
                  style: _normalizeStyle(relevanceTdStyle(30))
                }, [
                  _createElementVNode("div", {
                    class: "oneRowText",
                    style: _normalizeStyle(relevanceTdStyle(30)),
                    title: _unref($helper).lan('对应型号'),
                    innerHTML: '<strong>'+_unref($helper).lan('对应型号')+'</strong>'
                  }, null, 12, _hoisted_17)
                ], 4),
                _createElementVNode("td", {
                  class: "commonTdStyle",
                  style: _normalizeStyle(relevanceTdStyle(38))
                }, [
                  _createElementVNode("div", {
                    class: "oneRowText",
                    style: _normalizeStyle(relevanceTdStyle(38)),
                    title: _unref($helper).lan('区别说明'),
                    innerHTML: '<strong>'+_unref($helper).lan('区别说明')+'</strong>'
                  }, null, 12, _hoisted_18)
                ], 4)
              ], 512), [
                [_vShow, getRelevances(item.GloryModel).length>0]
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getRelevances(item.GloryModel), (relevance) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: relevance.PartNo+_unref($helper).createID()
                }, [
                  _createElementVNode("td", {
                    class: "commonTdStyle",
                    style: _normalizeStyle(relevanceTdStyle(30))
                  }, [
                    _createElementVNode("div", {
                      class: "oneRowText",
                      style: _normalizeStyle(relevanceTdStyle(30)),
                      title: _unref($helper).lan(relevance.Similar),
                      innerHTML: _unref($helper).lan(relevance.Similar)
                    }, null, 12, _hoisted_19)
                  ], 4),
                  _createElementVNode("td", {
                    class: "commonTdStyle",
                    style: _normalizeStyle(relevanceTdStyle(30))
                  }, [
                    _createElementVNode("div", {
                      class: "oneRowText",
                      style: _normalizeStyle(relevanceTdStyle(30)),
                      title: _unref($helper).lan(relevance.PartNo),
                      innerHTML: _unref($helper).lan(relevance.PartNo)
                    }, null, 12, _hoisted_20)
                  ], 4),
                  _createElementVNode("td", {
                    class: "commonTdStyle",
                    style: _normalizeStyle(relevanceTdStyle(38))
                  }, [
                    _createElementVNode("div", {
                      class: "oneRowText",
                      style: _normalizeStyle(relevanceTdStyle(38)),
                      title: _unref($helper).lan(relevance.Difference),
                      innerHTML: _unref($helper).lan(relevance.Difference)
                    }, null, 12, _hoisted_21)
                  ], 4)
                ]))
              }), 128))
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("tr", null, [
        _createElementVNode("td", _hoisted_22, [
          _createElementVNode("table", _hoisted_23, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_24, [
                _createElementVNode("strong", null, _toDisplayString(_unref($helper).lan('品牌特征')) + " ", 1)
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.brandProductFields, (field) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: field.filedCode,
                style: {"width":"100%"}
              }, [
                _createElementVNode("td", _hoisted_25, [
                  _createElementVNode("strong", null, _toDisplayString(_unref($helper).lan(field.filedName)) + " ", 1)
                ])
              ]))
            }), 128))
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.compareProducts, (item) => {
          return (_openBlock(), _createElementBlock("td", {
            key: item.GloryModel
          }, [
            _createElementVNode("table", _hoisted_26, [
              _hoisted_27,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(calBrandProducts(item.GloryModel), (brand) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: brand.id
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(brand.filedValues, (b) => {
                    return (_openBlock(), _createElementBlock("td", {
                      class: "commonTdStyle",
                      style: _normalizeStyle(brandProductTdStyle(30)),
                      key: b+_unref($helper).createID()
                    }, [
                      _createElementVNode("div", {
                        class: "oneRowText",
                        style: _normalizeStyle(brandProductTdStyle(30)),
                        title: b,
                        innerHTML: b
                      }, null, 12, _hoisted_28)
                    ], 4))
                  }), 128))
                ]))
              }), 128))
            ])
          ]))
        }), 128))
      ])
    ], 4), [
      [_vShow, data.compareProducts.length>0]
    ]),
    _createElementVNode("div", {
      onClick: enlarge,
      style: {"position":"absolute","right":"10px","top":"5px","z-index":"999","background-color":"#FFF","padding":"1px 3px","border":"1px solid #CCC","cursor":"pointer","border-radius":"5px"}
    }, "放大"),
    _createElementVNode("div", {
      onClick: reduce,
      style: {"position":"absolute","right":"10px","top":"35px","z-index":"999","background-color":"#FFF","padding":"1px 3px","border":"1px solid #CCC","cursor":"pointer","border-radius":"5px"}
    }, "缩小"),
    _createElementVNode("div", {
      onClick: resetSize,
      style: {"position":"absolute","right":"10px","top":"65px","z-index":"999","background-color":"#FFF","padding":"1px 3px","border":"1px solid #CCC","cursor":"pointer","border-radius":"5px"}
    }, "重置")
  ]))
}
}

})